"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.golf = exports.breakpoints = void 0;
//
// Define the breakpoints the manifest need to listen to.
//
const breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'large'];

//
// Golf translation ids
//
exports.breakpoints = breakpoints;
const golf = {
  close: 'Shared:UtilityBar:Close',
  discover: 'Sales:DiscoverNav:Heading',
  helpCenter: 'Shared:UtilityBar:SupportPhone:HelpCenter',
  home: 'PC:AppHeader:Header:Home',
  mainMenu: 'Shared:MobileNav:MainMenu',
  product: 'Sales:ProductNav:Heading',
  productPanel: 'Sales:ProductPanel:MenuTitle',
  signin: 'Shared:UtilityBar:AccountTray:SignIn'
};
exports.golf = golf;